import styled, { css } from 'styled-components'

import { LoaderObject } from '@/components/Loader/Loader.styles'
import { TransitionPrimary } from '@/lib/mixins'

export const PaymentPendingContent = styled.div`
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
  padding-bottom: 15%;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${LoaderObject} {
    margin-top: 2rem;
  }
`

interface PaymentPendingPointerProps {
  hide?: boolean
}

export const PaymentPendingPointer = styled.div<PaymentPendingPointerProps>`
  margin-top: auto;
  ${TransitionPrimary('opacity')};

  ${props =>
    props.hide &&
    css`
      opacity: 0;
    `};
`
